var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade modalShowImg", attrs: { id: "ShowImg" } },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { height: "100%" } },
            [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [_vm._v("×")]
              ),
              _vm._v(" "),
              _vm.file.type === "image/png" ||
              _vm.file.type === "image/jpeg" ||
              _vm.file.type === "image/jpg"
                ? _c("img", {
                    staticClass: "preview-upload",
                    attrs: { src: _vm.file.url }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.file.type === "image/tiff"
                ? _c(
                    "div",
                    { staticClass: "thumb-tiff", attrs: { id: "tiff" } },
                    [_vm._v(_vm._s(_vm.loadDetailImage(_vm.file.url, "tiff")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.file.type === "application/pdf"
                ? _c("pdf", {
                    staticClass: "thumb-pdf-detail",
                    attrs: { src: _vm.file.url }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ac9dfb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac9dfb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/ShowImg.vue
// module id = null
// module chunks = 